import React, { useState, useRef, useEffect } from "react";
import { Button } from 'primereact/button';
import axios from "axios";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import { Tag } from "primereact/tag";
import { MultiSelect } from "primereact/multiselect";
import { Message } from "primereact/message";
import { InputTextarea } from "primereact/inputtextarea";
import Spinner from "../../spinner/Spinner";
import { TabPanel, TabView } from "primereact/tabview";
import { RadioButton } from "primereact/radiobutton";


const MyModuleReservations = props => {
    const toast = useRef(null);
    const [allReservationList, setAllReservationList] = useState([]);
    const [pendingList, setPendingList] = useState([]);
    const [approvedReservationList, setApprovedReservationList] = useState([]);
    const [rejectReservationList, setRejectReservationList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [sssDeleteDialog, setSssDeleteDialog] = useState(false);
    const [umdID, setUmdID] = useState(null);
    const role_list = localStorage.getItem('role_list') ? true : false;
    const [globalFilter1, setGlobalFilter1] = useState('');
    const [descriptionDialogHeader, setDescriptionDialogHeader] = useState("");
    const [descriptionDialogContent, setDescriptionDialogContent] = useState("");
    const [descriptionDialog, setDescriptionDialog] = useState(false);
    const [acceptDialog, setAcceptDialog] = useState(false);
    const [roleValue, setRoleValue] = useState(null);
    const [mdID, setMdID] = useState(null);
    const [creditRejectedDescription, setCreditRejectedDescription] = useState("");
    const [loadingState, setLoadingState] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [pendingCount, setPendingCount] = useState(0);


    useEffect(() => {

        getUserModuleList()
        getApprovedReservations()
        getPendindApprovalReservations()
        getUserModuleListPending()


    }, []); //Buradaki dizi içine yazılan değer, değişince useeffecti çalıştır.


    const customer1TableHeader = (
        <div className="table-header" align="right">

            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                    placeholder="Genel Arama" />
            </span>
        </div>
    );
    const showSuccess = (message) => {
        toast.current.show({ severity: 'success', summary: message, detail: message, life: 5000 });
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 5000
        });
    }

    const getApprovedReservations = () => {
        let headers = { "Content-Type": "application/json" };
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/my-md-reservation/approved", { headers, method: "GET" })
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return { status: res.status, data };
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setApprovedReservationList(res.data.user_module_list_accept);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getPendindApprovalReservations = () => {
        let headers = { "Content-Type": "application/json" };
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/my-md-reservation/rejected", { headers, method: "GET" })
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return { status: res.status, data };
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;

                        if (data.result) {
                            setRejectReservationList(res.data.user_module_list_reject);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }


    const getUserRoleList = (umd_id, md_id) => {
        setMdID(md_id)
        setUmdID(umd_id)
        setAcceptDialog(true)
        const token = localStorage.getItem("token");
        const headers = { "Authorization": "Token " + token }
        axios.get('/api/md-roles/' + `${md_id}/`, { "headers": headers })
            .then(res => {
                setRoleList(res.data.user_role_list)
            })
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return { status: res.status, data };
                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })

            .then(res => {

                if (res.status === 401) {
                    props.loadUser();
                    throw res.data;
                } else if (res.status === 403) {
                    throw res.data;
                }
            })
    }

    const getUserModuleList = () => {
        const token = localStorage.getItem("token");
        const headers = { "Authorization": "Token " + token }
        axios.get('/api/my-md-reservation/all', { "headers": headers })
            .then(res => {
                setAllReservationList(res.data.user_module_list)
            })
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return { status: res.status, data };
                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })
            .then(res => {
                if (res.status === 401) {
                    props.loadUser();
                    throw res.data;
                } else if (res.status === 403) {
                    throw res.data;
                }
            })
    }

    const getUserModuleListPending = () => {
        const token = localStorage.getItem("token");
        const headers = { "Authorization": "Token " + token }
        axios.get('/api/my-md-reservation/pending', { "headers": headers })
            .then(res => {
                setPendingList(res.data.user_module_list)
                setPendingCount(res.data.count)
            })
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return { status: res.status, data };
                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })
            .then(res => {
                if (res.status === 401) {
                    props.loadUser();
                    throw res.data;
                } else if (res.status === 403) {
                    throw res.data;
                }
            })
    }
    const actionTemplate3 = (rowData) => {
        let status = rowData.umd_flag_permission
        if (status === null) {
            return <div>
                <React.Fragment>


                    <Tag className="mr-2" severity="warning" value="Onay Bekliyor" rounded />


                </React.Fragment>


            </div>;

        } else if (status === true) {
            return <div>
                <React.Fragment>

                    <Tag className="mr-2" severity="success" value="Onaylanmış" rounded />


                </React.Fragment>


            </div>;

        } else if (status === false) {
            return <div>
                <React.Fragment>


                    <Tag severity="danger" value="İptal Edilmiş" rounded />


                </React.Fragment>


            </div>;

        }

    }

    // const renderFooter = () => {
    //     return (
    //         <div>
    //
    //             <Button label="Hayır" icon="pi pi-times" onClick={() => setSssDeleteDialog(false)}
    //                     className="p-button-text"/>
    //             <Button label="Evet" icon="pi pi-check" onClick={() => deleteCip(umdID,)} autoFocus/>
    //         </div>
    //     );
    // }
    const deleteRow = (umd_id) => {


        setSssDeleteDialog(true)
        setUmdID(umd_id)


    }
    const submit = () => {
        const obj = {
            umdID: umdID,
            rolg_id: roleValue
        };

        let headers = { "Content-Type": "application/json" };
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);
            if (umdID) {
                fetch("/api/user-role-add/", { headers, method: "POST", body })
                    .then(res => {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return { status: res.status, data };
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            const data = res.data;

                            if (data.result) {
                                getUserModuleList()
                                getApprovedReservations()
                                getPendindApprovalReservations()
                                getUserModuleListPending()
                                setAcceptDialog(false)
                                showSuccess(data.message);
                            } else {
                                showError(data.message);
                                // this.setState({disable_submit_btn: false});
                            }
                        } else if (res.status === 401) {
                            props.loadUser();
                            throw res.data;

                        } else if (res.status === 403) {
                            throw res.data;

                        }
                    })
            }
        }


    }
    const ModuleOptionItems = roleList.map((item) => (
        { "label": item.rolg_name, "value": item.rolg_id }
    ))

    const deleteCip = (umd_id) => {
        if (creditRejectedDescription !== "") {
            const obj = {
                creditRejectedDescription: creditRejectedDescription

            }
            const token = localStorage.getItem("token");

            const headers = { "Authorization": "Token " + token }
            axios.put('api/md-reservation' + `/${umd_id}/`, obj, { "headers": headers })
                .then(res => {
                    const data = res.data
                    if (data.result) {
                        setCreditRejectedDescription('')
                        getUserModuleList()
                        getApprovedReservations()
                        getPendindApprovalReservations()
                        getUserModuleListPending()
                        showSuccess(data.message);

                    } else {
                        showError(data.message);
                    }
                    getUserModuleList()

                    setSssDeleteDialog(false)
                    setUmdID(null)


                });


        } else {
            showError("Başvuru iptal açıklaması boş bırakılamaz!");

        }
    }

        ;

    const actionTemplate2 = (rowData) => {
        let status = rowData.md_id
        if (status === 5) {
            return <div>
                <React.Fragment>


                    <Tag className="mr-2" severity="info" value="Değirmen Portal" rounded />


                </React.Fragment>


            </div>;

        } else if (status === 6) {
            return <div>
                <React.Fragment>

                    <Tag className="mr-2" severity="success" value="Model Eğitim Portal" rounded />


                </React.Fragment>


            </div>;

        } else if (status === 4) {
            return <div>
                <React.Fragment>


                    <Tag className="mr-2" severity="warning" value="Veri Kovanı Portal" rounded />


                </React.Fragment>


            </div>;
        } else if (status === 15) {
            return (
                <div>
                    <React.Fragment>
                        <Tag className="mr-2" severity="info" value="Kıyasla Portali" rounded />
                    </React.Fragment>
                </div>
            );
        } else if (status === 13) {
            return (
                <div>
                    <React.Fragment>
                        <Tag className="mr-2" severity="success" value="Eğitim Portali" rounded />
                    </React.Fragment>
                </div>
            );
        } else if (status === 14) {
            return (
                <div>
                    <React.Fragment>
                        <Tag className="mr-2" severity="warning" value="Simülasyon Portali" rounded />
                    </React.Fragment>
                </div>
            );
        }

    }

    const descriptionDialogOnDisplay = (header, content) => {
        setDescriptionDialogHeader(header);
        setDescriptionDialogContent(content);
        setDescriptionDialog(true);
    }
    const rejectDialog = () => {
        setAcceptDialog(false)
        setRoleValue('')
    }

    const descriptionDialogOnHide = () => {
        setDescriptionDialogHeader("");
        setDescriptionDialogContent("");
        setDescriptionDialog(false);
    }

    const getDescriptionBody = (key, title) => {
        const descriptionBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{title}</span>
                            </div>

                            <div className="p-col-12" style={{ wordBreak: "break-all" }}>
                                {rowData[key].umd_reservation_reason
                                    ?
                                    rowData[key].umd_reservation_reason.length > 20
                                        ?
                                        <div>
                                            {rowData[key].umd_reservation_reason.substring(0, 20) + "..."}
                                            <Button label="Devamını Oku"
                                                onClick={(e) => descriptionDialogOnDisplay(title, rowData[key].umd_reservation_reason)}
                                                className="p-button-text"
                                            />
                                        </div>
                                        :
                                        rowData[key].umd_reservation_reason
                                    :
                                    <span><b>-</b></span>
                                }
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return descriptionBody;
    }

    const roleTemplate = (key) => {
        const descriptionBody = (rowData) => {
            return (
                <div className="p-grid">

                    {rowData[key].select_role
                        ?
                        <div className="p-col-12">
                            {rowData[key].select_role.map((role) =>

                                <p>
                                    {role === "annotations"
                                        ?
                                        "Veri Seti Sağlayıcısı"
                                        :
                                        role === "annotate"
                                            ?
                                            "Aday Etiketleyici"
                                            :
                                            role}
                                </p>
                            )}
                        </div>

                        :
                        <span><b>-</b></span>
                    }
                </div>
            );
        }
        return descriptionBody;
    }

    const actionTemplate = (rowData) => {
        return <div>


            <Button icon="pi pi-check" className=" p-button-success p-mr-2" tooltip="Onayla"

                onClick={() => getUserRoleList(rowData.umd_id, rowData.md_id)}
                tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
            />


            <Button icon="pi pi-times" className=" p-button-danger"

                onClick={() => deleteRow(rowData.umd_id)}
                tooltip="Reddet"
                tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
            />


        </div>;
    }


    return (

        <div>
            <Spinner loadingState={loadingState} />
            <Dialog header="UYARI" visible={sssDeleteDialog}
                style={{ width: '50%' }}

                onHide={() => setSssDeleteDialog(false)}>
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="p-field p-md-4 p-mt-5" style={{ width: '100%' }}>
                            <span className="p-float-label">
                                <InputTextarea id="rejectedDescription" value={creditRejectedDescription}
                                    onChange={(e) => setCreditRejectedDescription(e.target.value)}
                                    rows={3}
                                    style={{ width: '100%' }}
                                />
                                <label htmlFor="rejectedDescription">Kredi İptal Açıklaması</label>
                            </span>
                        </div>
                    </div>
                    <div className="p-col-12" align="right">
                        <Button label="İptal Et"
                            className="p-button-danger"
                            icon="pi pi-times"
                            onClick={() => deleteCip(umdID)} />
                    </div>
                </div>


            </Dialog>

            <Dialog visible={descriptionDialog}
                onHide={descriptionDialogOnHide}
                header={descriptionDialogHeader}
                style={{ width: '75%' }}
                dismissableMask
            >
                <div className="p-grid">
                    <div className="p-col-12">
                        <p style={{ fontSize: '1.25rem' }}> {descriptionDialogContent} </p>

                    </div>
                </div>
            </Dialog>
            <Dialog visible={acceptDialog}
                onHide={rejectDialog}
                header="Başvuru Onayla"
                style={{ width: '60%' }}
                maximizable
                dismissableMask
            >
                <div className="p-grid">
                    <div className="p-col-12" align="center">
                        <Message severity="info" className="p-mt-2 p-mb-2"
                            text="Kullanıcıya tanımlamak istediğiniz rol gruplarını seçiniz." />
                        <MultiSelect value={roleValue}
                            options={ModuleOptionItems}
                            onChange={(e) => setRoleValue(e.value)} optionLabel="label"
                            placeholder="Rol Gruplarını Seçiniz" display="chip"
                            style={{ width: '75%', align: 'center' }} />
                    </div>
                    <div className="p-col-12 p-mt-5" align="right">
                        <Button label="Onayla"
                            className="p-button-success"
                            icon="pi pi-check"
                            onClick={(e) => submit(umdID)} />
                    </div>
                </div>
            </Dialog>
            <Toast ref={toast} />
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header="Tümü">
                    <div className="datatable-responsive-demo">

                        <div className="card">
                            <h5><b>Portal Kullanım Başvurularım</b></h5>
                            <p>Sayfalandırma, sıralama ve filtreleme </p>
                            <DataTable
                                responsive={true}
                                value={allReservationList}
                                paginator
                                resizableColumns={true}
                                className="p-datatable-responsive-demo"
                                rows={10} dataKey="id"
                                rowHover globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                header={customer1TableHeader}

                            >
                                <Column
                                    field={'umd_id'}
                                    header="No"
                                    style={{ fontWeight: 'bold', width: '5.5em' }}
                                    sortable


                                />
                                <Column
                                    body={actionTemplate3}
                                    header="Durumu"
                                    style={{ fontWeight: 'bold' }}


                                />


                                <Column
                                    field={'user__user_username'}
                                    header="Talepte Bulunan"
                                    filter
                                    style={{ textAlign: 'center' }}


                                />

                                <Column field="umd_reservationreason"
                                    header="Talep Açıklaması"
                                    body={getDescriptionBody("umd_reservationreason", "Talep Açıklaması")}
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"
                                />

                                <Column field="umd_reservationreason"
                                    header="Talep Edilen Roller"
                                    body={roleTemplate("umd_reservationreason")}
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"
                                />

                                <Column
                                    body={actionTemplate2}
                                    header="Modül"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    filterMatchMode="contains"
                                    filterField="md__md_name"
                                    sortable={true}
                                    filter={true}


                                />
                                <Column
                                    field={'umd_reservationtime'}
                                    header="Oluşturulma Tarihi"
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filterMatchMode="contains"


                                />
                                <Column
                                    field={'umd_starttime'}
                                    header="Başlangıç Tarihi"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    sortable={true}
                                    filterMatchMode="contains"


                                />
                                <Column
                                    field={'umd_finishtime'}
                                    header="Bitiş Tarihi"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    sortable={true}
                                    filterMatchMode="contains"
                                />


                            </DataTable>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={<div style={{ color: 'red' }}>Onay Bekleyen Başvurularım ({pendingCount})
                </div>}>
                    <div className="datatable-responsive-demo">

                        <div className="card">
                            <h5><b>Onay Bekleyen Başvurularım</b></h5>
                            <p>Sayfalandırma, sıralama ve filtreleme </p>
                            <DataTable
                                responsive={true}
                                value={pendingList}
                                paginator
                                resizableColumns={true}
                                className="p-datatable-responsive-demo"
                                rows={10} dataKey="id"
                                rowHover globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                header={customer1TableHeader}

                            >
                                <Column
                                    field={'umd_id'}
                                    header="No"
                                    style={{ fontWeight: 'bold', textAlign: 'left', width: '5.5em' }}
                                    sortable


                                />

                                <Column
                                    body={actionTemplate2}
                                    header="Modül"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    filterMatchMode="contains"
                                    filterField="md__md_name"
                                    sortable={true}
                                    filter={true}


                                />

                                <Column
                                    field={'user__user_username'}
                                    header="Talepte Bulunan"
                                    filter
                                    style={{ textAlign: 'center' }}


                                />

                                <Column field="umd_reservationreason"
                                    header="Talep Açıklaması"
                                    body={getDescriptionBody("umd_reservationreason", "Talep Açıklaması")}
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"
                                />
                                <Column
                                    field={'umd_reservationtime'}
                                    header="Oluşturulma Tarihi"
                                    style={{ textAlign: 'center' }}
                                    sortable
                                    filter={true}
                                    filterMatchMode="contains"


                                />
                                <Column
                                    field={'umd_starttime'}
                                    header="Başlangıç Tarihi"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    sortable
                                    filter={true}
                                    filterMatchMode="contains"


                                />
                                <Column
                                    field={'umd_finishtime'}
                                    header="Bitiş Tarihi"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    sortable
                                    filter={true}
                                    filterMatchMode="contains"


                                />


                            </DataTable>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="Onaylanmış Başvurularım">
                    <div className="datatable-responsive-demo">

                        <div className="card">
                            <h5><b>Onaylanmış Başvurularım</b></h5>
                            <p>Sayfalandırma, sıralama ve filtreleme </p>
                            <DataTable
                                value={approvedReservationList}
                                className='p-datatable-responsive-demo'
                                paginator rows={10}
                                emptyMessage="Kayıt Bulunamadı"
                                globalFilter={globalFilter1}
                                header={customer1TableHeader}
                            >
                                <Column
                                    field={'umd_id'}
                                    header="No"
                                    style={{ fontWeight: 'bold', textAlign: 'left', width: '5.5em' }}
                                    sortable


                                />

                                <Column
                                    body={actionTemplate2}
                                    header="Modül"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    sortable
                                    filterMatchMode="contains"
                                    filterField="md__md_name"
                                    filter={true}


                                />

                                <Column
                                    field={'user__user_username'}
                                    header="Talepte Bulunan"
                                    filter
                                    style={{ textAlign: 'center' }}


                                />


                                <Column field="umd_reservationreason"
                                    header="Talep Açıklaması"
                                    body={getDescriptionBody("umd_reservationreason", "Talep Açıklaması")}
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"
                                />
                                <Column
                                    field={'umd_reservationtime'}
                                    header="Oluşturulma Tarihi"
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"


                                />
                                <Column
                                    field={'umd_controltime'}
                                    header="Kontrol Tarihi"
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"


                                />
                                <Column
                                    field={'umd_starttime'}
                                    header="Başlangıç Tarihi"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"


                                />
                                <Column
                                    field={'umd_finishtime'}
                                    header="Bitiş Tarihi"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"


                                />


                            </DataTable>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="Reddedilen Başvurularım">
                    <div className="datatable-responsive-demo">

                        <div className="card">
                            <h5><b>Reddedilen Başvurularım</b></h5>
                            <p>Sayfalandırma, sıralama ve filtreleme </p>

                            <DataTable
                                value={rejectReservationList}
                                className='p-datatable-responsive-demo'
                                paginator rows={10}
                                emptyMessage="Kayıt Bulunamadı"
                                globalFilter={globalFilter1}
                                header={customer1TableHeader}
                            >
                                <Column
                                    field={'umd_id'}
                                    header="No"
                                    style={{ fontWeight: 'bold', textAlign: 'left', width: '5.5em' }}
                                    sortable


                                />

                                <Column
                                    body={actionTemplate2}
                                    header="Modül"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    filterMatchMode="contains"
                                    filterField="md__md_name"
                                    sortable={true}
                                    filter={true}


                                />

                                <Column
                                    field={'user__user_username'}
                                    header="Talepte Bulunan"
                                    filter
                                    style={{ textAlign: 'center' }}


                                />

                                <Column
                                    body={getDescriptionBody("umd_controldesctiption", "Değerlendirme")}
                                    field={'umd_controldesctiption'}
                                    header="Değerlendirme"
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"


                                />


                                <Column field="umd_reservationreason"
                                    header="Talep Açıklaması"
                                    body={getDescriptionBody("umd_reservationreason", "Talep Açıklaması")}
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"
                                />
                                <Column
                                    field={'umd_reservationtime'}
                                    header="Oluşturulma Tarihi"
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"


                                />
                                <Column
                                    field={'umd_controltime'}
                                    header="Kontrol Tarihi"
                                    style={{ textAlign: 'center' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"


                                />
                                <Column
                                    field={'umd_starttime'}
                                    header="Başlangıç Tarihi"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"


                                />
                                <Column
                                    field={'umd_finishtime'}
                                    header="Bitiş Tarihi"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}
                                    sortable={true}
                                    filter={true}
                                    filterMatchMode="contains"


                                />
                            </DataTable>

                        </div>

                    </div>

                </TabPanel>

            </TabView>
        </div>

    )


}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MyModuleReservations);



// WEBPACK FOOTER //
// ./src/pages/modulemanagement/MyModuleReservations.jsx